export default __webpack_public_path__ + "static/hexShadow-ee2210d339717d88d52576267c7c4233.png";